export function isEmptyControlValue(value) {
  if (value === null || value === undefined) return true;
  if (typeof value === 'string') return value.trim() === '';
  if (Array.isArray(value)) return value.length === 0;
  if (typeof value === 'object') {
    if ('value' in value) return isEmptyControlValue(value.value);
    return Object.keys(value).length === 0;
  }
  return false;
}
